<script>
  import Square from "./Square.svelte"
  import Sun from "./Sun.svelte";
  import Temperature from "./Temperature.svelte"
  export let data;

  console.log(data);

  const formatTemp = (temp) => {
    return Math.round((temp - 273.15) * 10) / 10;
  };
</script>

<div class="flex">

  <Square>
    <Sun sunrise={data.sys.sunrise} sunset={data.sys.sunset} />
  </Square>

  <Square>
    <Temperature
      temp={formatTemp(data.main.temp)}
      pressure={data.main.pressure}
      humidity={data.main.humidity}
    />
  </Square>

</div>


<style lang="scss">
  .flex {
    display: flex;
    justify-content: space-between;
  }
</style>
